import { render, staticRenderFns } from "./TarifarioForm.vue?vue&type=template&id=1286eda0"
import script from "./TarifarioForm.vue?vue&type=script&lang=js"
export * from "./TarifarioForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports